// src/App.js
import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import LogoBubble from './components/LogoBubble';

import Seo from './components/Seo';
import Layout from './components/Layout';
import Hero from './components/Hero';
import LeadForm from './components/LeadForm';
import Portfolio from './components/Portfolio';
import Benefits from './components/Benefits';
import Services from './components/Services';
import Testimonials from './components/Testimonials';
import FinalCta from './components/FinalCta';
import feedback1 from './assets/feeback1.mp4'
import './styles.css';
import VideoTestimonial from './components/VideoPortfolio';

function App() {
  const myVideos = [
    {
      name: "V. Veeramani",
      role: "V Team",
      content: "The modular architecture and seamless functionality of the website exceeded our expectations. The attention to detail in the design and user interface reflects true professionalism and technical expertise.",
      videoUrl: feedback1, // Your imported video file
      rating: 5,
    },

  ];
  return (
    <HelmetProvider>
      <div className="app">
        <LogoBubble />
        <Seo />
        <Layout>
          <Hero />
          <LeadForm />
          <VideoTestimonial videos={myVideos} />
          <Portfolio />
          <Benefits />
          <Services />
          <Testimonials />
          <FinalCta />
        </Layout>

      </div>
    </HelmetProvider>
  );
}

export default App;
